import React, { useState } from "react";
import { Input, InputGroup, Row, Col } from "reactstrap";

function InputEmail(props) {
  const [email, setEmail] = useState("");

  const handleEmailChange = (e) => {
    const enteredEmail = e.target.value.trim();
    setEmail(enteredEmail);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(enteredEmail);
    if (!isValidEmail) {
        props.setEmailError(true);
    }
    else {
        props.setEmailError(false);
    }
    if (props.onChange) {
      props.onChange(e);
    }
  };
  return (
    <Row>
      <Col md="12">
        <InputGroup className={props.className}>
          <Input
            name={props.name}
            type="email"
            placeholder={props.placeholder}
            autoComplete="email"
            value={email}
            onChange={handleEmailChange}
          />
        </InputGroup>
      </Col>
    </Row>
  );
}

export default InputEmail;
